import uiRouter from '@uirouter/angularjs';
import { LoadScriptResolver, UserConfigDataResolver, TenantDataResolver, ThemesDataResolver } from '@b2b/common/resolvers';
import angular from 'angular';
import { OrdersPrintControllerModule } from './controllers/OrdersPrintController';

export const OrdersPrintView = angular
  .module('acme.view.application.orders.print', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.directive.dataGrid',
    OrdersPrintControllerModule,
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const ordersPrint = {
      name: 'application.orders.print',
      url: '/print',
      abstract: true,
      views: {
        'main@': {
          controller: 'OrdersPrintController',
          templateUrl: 'layouts/print.tpl.html',
        },
      },
      resolve: {
        JQueryPrint: LoadScriptResolver({ id: 'jquery-print-js', url: '/assets/jquery-print.js' }),
        UserConfigData: UserConfigDataResolver(),
        TenantData: TenantDataResolver(),
        ThemesData: ThemesDataResolver(),
      },
    };

    const ordersPrintDefault = {
      name: 'application.orders.print.default',
      url: '',
      views: {
        'subview-main@application.orders.print': {
          templateUrl: 'views/application/views/orders/print/print.tpl.html',
        },
      },
      data: {
        pageTitle: 'Print Order Summary',
      },
    };

    const ordersPrintInvoice = {
      name: 'application.orders.print.invoice',
      url: '/invoice',
      views: {
        'subview-main@application.orders.print': {
          templateUrl: 'views/application/views/orders/print/print.tpl.html',
        },
      },
      data: {
        pageTitle: 'Print Invoice',
      },
    };

    $stateProvider.state(ordersPrint).state(ordersPrintDefault).state(ordersPrintInvoice);
  }).name;
